import { Button } from '@optools/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@optools/components/ui/dialog';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@optools/components/ui/table';
import { LoggerGameTeam } from '@optools/services/operator-gateway/logger/types';
import { selectListenLinesConfig } from '@optools/store/configApiSlice';
import { useAppSelector } from '@optools/store/hooks';
import { ExternalLink } from 'lucide-react';
import { useMemo } from 'react';

export interface ListenLinesProps {
  team?: LoggerGameTeam;
}

export function ListenLines({ team }: ListenLinesProps) {
  const listenLinesConfig = useAppSelector(selectListenLinesConfig);
  const abbreviation = team?.abbreviation;
  const lines = useMemo(
    () => listenLinesConfig.listenLines.filter((line) => line.team === abbreviation),
    [listenLinesConfig, abbreviation],
  );

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className="gap-2" variant="outline">
          AD Phone
          <ExternalLink />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>AD Phone Lines</DialogTitle>
          <DialogDescription className="sr-only">
            phone numbers AD for coordination
          </DialogDescription>
        </DialogHeader>
        {lines.length > 0 ? (
          <Table containerClassName="h-full rounded-md border">
            <TableHeader className="sticky top-0 bg-background">
              <TableRow>
                <TableHead>Network</TableHead>
                <TableHead>Number</TableHead>
                <TableHead>Code</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {lines.map(({ code, network, number }) => (
                <TableRow key={network + number + code}>
                  <TableCell>{network}</TableCell>
                  <TableCell>{number}</TableCell>
                  <TableCell>{code}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="flex items-center justify-center">
            <p className="text-lg font-semibold">No Listen Lines Found</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
